module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "sec4"
    }
  }), _vm._v("Mrs. Autumn and Her Two Daughters")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We live in an ocean"), _c('br'), _vm._v("of white waiting to fall."), _c('br'), _vm._v("One of us is not like our mother and it’s me. It’s I."), _c('br'), _vm._v("My eyes are mostly closed.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My mother knows"), _c('br'), _vm._v("how to make snow. We never see"), _c('br'), _vm._v("our feet. Our skirts end in the oncoming frost."), _c('br'), _vm._v("My sister wears ermine. I have a narrow waist.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I no longer curl my hair. Why bother?"), _c('br'), _vm._v("I love my sister but hate my mother"), _c('br'), _vm._v("yet we’re all of a piece."), _c('br'), _vm._v("Endless snipsnip. Ragged fragment.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We still live where you last left us—"), _c('br'), _vm._v("between the palace where you keep your winter"), _c('br'), _vm._v("and the summer garden of the ersatz emperor."), _c('br'), _vm._v("Did I hear you say China? If I did you are right.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We live atop the continent"), _c('br'), _vm._v("that contains such poverty. Such pollution."), _c('br'), _vm._v("Such eerie beauty. Always a mountain."), _c('br'), _vm._v("Always a screen. White washes")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("over me. I do not act"), _c('br'), _vm._v("like my mother. I lean farther."), _c('br'), _vm._v("What I make annihilates the mirror of China"), _c('br'), _vm._v("but not the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Not the man walking away."), _c('br'), _vm._v("My mother says throw more snow but I can’t"), _c('br'), _vm._v("help thinking."), _c('br'), _vm._v("There is more to being than erasure.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You are wrong, she says. You don’t wear your cape.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b6be878","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_a.vue
// module id = 87
// module chunks = 0